<template>
  <!-- 创建积分优惠券 -->
  <div class="create_coupons" v-if="isShow">
    <div class="backBox">
      <img
        class="pointer"
        @click="retrunMethod()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <template v-if="activityData && activityData.name">
        <span class="backBox_name">{{ activityData.name }}</span>
      </template>
      <template v-else>
        <span class="txt" v-if="tabActive == 10" @change="changeTab(tabActive)"
          >创建积分优惠券</span
        >
        <span class="txt" v-if="tabActive == 9" @change="changeTab(tabActive)"
          >创建积分兑换实物</span
        >
      </template>
    </div>
    <div :class="{ formBox: localStep != 0 }">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <div class="firststep" v-if="localStep == 0">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(123,97,255,0.15);"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05);"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height:432px;border-radius: 8px;"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width:100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    style="width:100%;max-height: 380px;"
                    :src="item.templateUrl"
                    alt=""
                  />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="localStep == 1">
        <!-- 兑换表单 -->
        <main class="main">
          <span
            style="color: red; line-height: 40px;font-size: 14px;margin-left: 40px;"
            v-if="tabActive == 9"
            >温馨提示：实物礼品系统帮助收集消费者的邮寄地址，商家自己线下发货，商家承担运费。</span
          >
          <el-form :model="form" :rules="rules" ref="form" label-width="120px">
            <el-form-item label="礼品名称:" v-if="tabActive == 10" required>
              <el-input
                v-model="form.activityName"
                maxlength="15"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <!-- 活动对象 -->
            <information
              v-if="tabActive == 10" 
              ref="information" 
              v-model="ruleDTO" 
              :isStart="isDisabled"
            />
            <el-form-item label="礼品名称:" v-if="tabActive == 9" required>
              <el-input
                v-model="form.activityName"
                maxlength="15"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 320px"
              ></el-input>
              <!-- <el-button
                type="primary"
                style="margin-left: 80px; width: 120px;"
                @click="dialogForm"
                :disabled="isDisabled"
                >选择本店商品</el-button
              > -->
              <el-button
                type="primary"
                style="margin-left: 80px; width: 120px;"
                @click="openPrize"
                :disabled="isDisabled"
                >选择奖品</el-button
              >
            </el-form-item>

            <el-form-item label="礼品价值:" v-if="tabActive == 9">
              <el-input
                v-model="form.price"
                @input="form.price = getNumberData(1, $event, 1, 0)"
                show-word-limit
                style="width: 136px"
                :disabled="isDisabled"
              ></el-input
              >&nbsp;元
            </el-form-item>

            <el-form-item label="礼品图片:" v-if="tabActive == 9" required>
              <div></div>
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :http-request="httpRequest"
                :disabled="isDisabled"
              >
                <img
                  v-if="(form.wareId || form.isGoodManage) && form.logo"
                  :src="form.logo"
                  style="width: 146px; height: 146px"
                />
                <i class="el-icon-plus" v-else></i>
              </el-upload>
              <span style="color: red; font-size: 14px"
                >建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span
              >
            </el-form-item>
            <!-- 活动对象 -->
            <information
              v-if="tabActive == 9" 
              ref="information" 
              v-model="ruleDTO" 
              :isStart="isDisabled"
            />
            <template v-if="tabActive == 9">
              <el-form-item label="参与条件：">
                <div>
                  <el-radio-group v-model="ruleDTO.exchangeConditions" :disabled="isDisabled">
                    <el-radio :label="0">满足参与身份即可参与</el-radio>
                    <el-radio :label="1">先下单后参与</el-radio>
                  </el-radio-group>
                </div>
                <div
                  v-if="ruleDTO.exchangeConditions == 1"
                  style="padding: 20px 0; background-color: #f2f2f2;margin-top: 16px;"
                >
                  <el-form-item label="下单时间：" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleDTO.orderStartTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 150px; font-size: 12px"
                        class="time1"
                        :clearable="false"
                        :disabled="isDisabled"
                        :picker-options="{
                          disabledDate(time) {
                            return (
                              ruleDTO.orderEndTime &&
                              time.getTime() >
                                new Date(ruleDTO.orderEndTime).getTime()
                            );
                          },
                        }"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleDTO.orderEndTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 160px; font-size: 12px"
                        class="time2"
                        :clearable="false"
                        :disabled="isDisabled"
                        :picker-options="{
                          disabledDate(time) {
                            return (
                              (endTime &&
                                time.getTime() >
                                  new Date(endTime).getTime()) ||
                              time.getTime() <
                                new Date(ruleDTO.orderStartTime).getTime()
                            );
                          },
                        }"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="ruleDTO.orderEndTime = '';ruleDTO.orderStartTime ='y'"
                      ></i>
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item label="金额统计类型：" required>
                    <el-radio-group v-model="ruleDTO.orderPaymentType" :disabled="isDisabled">
                      <el-radio :label="0" v-if="venderType!=1">实付金额</el-radio>
                      <el-radio :label="1">订单金额</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="商品要求：" required>
                    <div class="flexc-cen-x">
                      <el-radio-group 
                        v-model="ruleDTO.filterType" 
                        :disabled="isDisabled"
                        @change="ruleDTO.filterType == 0 ? itemListForFilter = [] : ''"
                      >
                        <el-radio :label="0">全部商品</el-radio>
                        <el-radio :label="1">指定商品</el-radio>
                        <el-radio :label="2">排除商品</el-radio>
                      </el-radio-group>
                      <el-button 
                        style="margin-left: 12px;"
                        :disabled="ruleDTO.filterType == 0 || isDisabled"
                        @click="selectGoodsState = true"
                      >
                        已选择{{ isDisabled ? ruleDTO.skuIdList && ruleDTO.skuIdList.length : itemListForFilter.length }}个
                      </el-button>
                    </div>
                    <div style="margin-top: 16px;" v-if="ruleDTO.filterType == 1">
                      <el-select
                        v-model="ruleDTO.filterSkuType"
                        :disabled="isDisabled"
                        placeholder="请选择"
                        style="width: 320px"
                      >
                        <template v-if="ruleDTO.filterType == 1">
                          <el-option label="只要订单包含指定商品就整单计算" :value="0" />
                          <el-option label="仅统计订单内指定商品的金额和件数" :value="1" />
                        </template>
                        <!-- <template v-if="ruleDTO.filterType == 2">
                          <el-option label="只要订单包含指定商品就整单排除" :value="0" />
                          <el-option label="仅统计订单内非排除商品的金额和件数" :value="1" />
                        </template> -->
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="商品件数：">
                    <el-input
                      v-model="ruleDTO.itemLimitCount"
                      :disabled="isDisabled"
                      @input="
                        ruleDTO.itemLimitCount = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          99999,
                        )
                      "
                      style="width: 120px"
                      placeholder="请输入"
                    />
                    <span class="ml6">件及以上</span>
                  </el-form-item>
                  <el-form-item label="订单金额：" required>
                    <el-input
                      v-model="ruleDTO.orderPaymentLimit"
                      :disabled="isDisabled"
                      @input="
                        ruleDTO.orderPaymentLimit = getNumberData(
                          1,
                          $event,
                          1,
                          0,
                          9999999,
                        )
                      "
                      style="width: 120px"
                      placeholder="请输入"
                    />
                    <span class="ml6">元及以上</span>
                  </el-form-item>
                  <el-form-item label="订单状态：" required>
                    <el-radio-group v-model="ruleDTO.orderType" :disabled="isDisabled">
                      <el-radio :label="0">已付款</el-radio>
                      <el-radio :label="1">已完成</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="统计规则：" required>
                    <el-radio-group v-model="ruleDTO.orderCountType" :disabled="isDisabled">
                      <el-radio :label="0">按单笔订单统计</el-radio>
                      <el-radio :label="1">按累计订单统计</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="下单跳转链接：">
                    <div>
                      <el-radio-group v-model="ruleDTO.goShopSetting" :disabled="isDisabled">
                        <el-radio :label="0">进入店铺首页</el-radio>
                        <el-radio :label="1">跳转指定小程序</el-radio>
                        <el-radio :label="2">进入指定链接</el-radio>
                      </el-radio-group>
                    </div>
                    <div style="margin-top: 16px;">
                      <el-form-item
                        v-if="ruleDTO.goShopSetting == 1"
                        label="小程序appId："
                        required
                      >
                        <el-input
                          v-model="ruleDTO.goShopAppId"
                          :disabled="isDisabled"
                          placeholder="请输入小程序appId"
                          style="width: 320px"
                        />
                      </el-form-item>
                      <el-form-item
                        v-if="ruleDTO.goShopSetting != 0"
                        :label="
                          ruleDTO.goShopSetting == 1
                            ? '页面路径path:'
                            : '指定链接：'
                        "
                        :required="ruleDTO.goShopSetting == 2"
                      >
                        <div>
                          <el-input
                            v-model="ruleDTO.goShopUrl"
                            :disabled="isDisabled"
                            placeholder="请输入"
                            style="width: 320px"
                          />
                        </div>
                        <div style="color: red; font-size: 12px">
                          {{
                            ruleDTO.goShopSetting == 1
                              ? "注意：path若不写，则默认进入小程序主页"
                              : "注意：仅可填写京东域内的H5页面地址，不可设置外链。参考链接：https://m.jd.com/。"
                          }}
                        </div>
                      </el-form-item>
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
            </template>
            <el-form-item label="添加优惠券:" v-if="tabActive == 10" required>
              <button
                class="addBtn"
                @click.prevent="onShowAddCoupon()"
                v-if="butActive == 1"
                :disabled="isDisabled"
              >
                添加优惠券
              </button>
              <div v-if="butActive == 2 && venderType == false">
                <div class="couponContent">
                  <div class="txtNum">
                    ￥
                    <span style="font-size: 36px; color: #7B61FF">{{
                      couponTxt.discount
                    }}</span>
                  </div>
                  <div class="txtSize">
                    满 {{ couponTxt.quota }} 元可使用 <br />
                    {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
                  </div>
                  <p class="time">
                    <!-- 有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }} -->
                               <span v-if="couponTxt.validityType == 5">
                        有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}
                       </span>
                       <span v-else>
                         领取后{{ couponTxt.addDays }}天有效
                       </span>
                  </p>
                  <div class="background"></div>
                  <div class="btn">
                    <el-button
                      @click="createActivity"
                      type="primary"
                      size="small"
                      :disabled="isDisabled"
                      >重新选择</el-button
                    >
                  </div>
                </div>
                <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
                <p class="pContent">发行量：{{ couponTxt.num }}</p>
                <br />
                <p class="pContent">
                  领券开始时间：{{ couponTxt.tekeBeginTime }}
                </p>
                <p class="pContent">
                  领券结束时间：{{ couponTxt.takeEndTime }}
                </p>
                <br />
                <p class="pContent">
                  限领规则：{{
                    couponTxt.takeRule == 5
                      ? "活动期间限领一张"
                      : "每天限领一张"
                  }}
                </p>
              </div>

              <div v-if="butActive == 2 && venderType == true">
                <div class="couponContent">
                  <div class="txtNum">
                    ￥
                    <span style="font-size: 36px; color: #7B61FF">{{
                      couponTxt.discount
                    }}</span>
                  </div>
                  <div class="txtSize">
                    满 {{ couponTxt.quota }} 元可使用 <br />
                    {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
                  </div>
                  <p class="time">
                    <!-- 有效期:{{ couponTxt.startTime }}~{{ couponTxt.endTime }} -->
                               <span v-if="couponTxt.validityType == 5">
                        有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}
                       </span>
                       <span v-else>
                         领取后{{ couponTxt.addDays }}天有效
                       </span>
                  </p>
                  <div class="background"></div>
                  <div class="btn">
                    <!-- <el-button
                      @click="butActive = 1"
                      type="primary"
                      size="small"
                      >取消</el-button
                    > -->
                    <el-button
                      @click="createActivity"
                      type="primary"
                      size="small"
                      >重新选择</el-button
                    >
                  </div>
                </div>
                <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
                <p class="pContent">发行量：{{ couponTxt.num }}</p>
                <br />
                <p class="pContent">
                  领券开始时间：{{ couponTxt.takeBeginTime }}
                </p>
                <p class="pContent">
                  领券结束时间：{{ couponTxt.takeEndTime }}
                </p>
                <br />
                <p class="pContent">
                  限领规则：{{
                    couponTxt.takeRule == 5
                      ? "活动期间限领一张"
                      : "每天限领一张"
                  }}
                </p>
              </div>
            </el-form-item>

            <el-form-item label="每人限兑次数:">
              <div class="limitBox">
                <el-input
                  v-model="form.exchangeTimes"
                  @input="form.exchangeTimes = getNumberData(1, $event, 0, 1)"
                  style="width: 136px"
                  :disabled="isDisabled"
                ></el-input
                >&nbsp;次
                <p class="desc">
                  <img
                    src="@/assets/images/new_icon_reminder1.png"
                    style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 9px 4px 0 3px;
                  "
                  />
                  不填则默认不限
                </p>
              </div>
            </el-form-item>
            <!-- required -->
            <el-form-item label="总份数:" v-if="tabActive == 9" required>
              <el-input
                v-model="form.quantityTotal"
                @input="form.quantityTotal = getNumberData(1, $event, 0, 0)"
                style="width: 136px"
                :disabled="isDisabled"
              ></el-input>
            </el-form-item>

            <el-form-item label="上下架时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.startTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 135px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                  :disabled="isDisabled && tabActive == 10"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  :clearable="false"
                  :disabled="isDisabled && tabActive == 10"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime">
                活动持续
                <span style="color: #7B61FF">{{ timeDay }}</span> 天
                <span style="color: #7B61FF">{{ timeOut }}</span> 小时
              </span>
            </el-form-item>

            <el-form-item label="兑换所需等级:" required>
              <div class="level-wrap">
                <el-checkbox-group v-model="memberLe" @change="checkListchange" :disabled="isDisabled">
                  <el-checkbox :label="memberLe">全部</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group
                  v-model="level"
                  v-for="(item, index) in memberLevelList"
                  :key="index"
                  @change="checkTheChange"
                  :disabled="isDisabled"
                >
                  <el-checkbox
                    :label="item.value"
                    :disabled="memberLe == true"
                    v-if="item.label"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item label="兑换所需积分:" required>
              <div class="isLevelSet" style="width: 600px">
                <template v-if="!isLevelSet">
                  <el-input
                    v-model.number="form.memberLevelPoints"
                    @input="
                      (form.memberLevelPoints = getNumberData(1, $event, 0, 0)),
                        updata()
                    "
                    style="width: 136px; margin-right: 20px"
                    :disabled="isDisabled"
                  ></el-input>
                </template>
                <template v-else>
                  <ul class="levelList">
                    <li
                      class="item"
                      v-for="item in memberLevelList"
                      :key="item.value"
                    >
                      {{ item.label }}
                      <el-input
                        v-model.number="item.point"
                        placeholder="请输入..."
                        @input="item.point = getNumberData(1, $event, 0, 0)"
                        style="width: 80px"
                      ></el-input>
                      积分
                    </li>
                  </ul>
                </template>
                <button class="setBtn" @click.prevent="isLevel" :disabled="isDisabled">
                  {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
                </button>
              </div>
            </el-form-item>

            <el-form-item label="规则说明:" required>
              <div
                style="
                width: 720px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding-top: 8px;
              "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 704px"
                  resize="none"
                  :rows="6"
                  v-model="form.ruleDescription"
                ></el-input>

                <div style="margintop: 8px">
                  <el-button
                    type="primary"
                    class="generate"
                    plain
                    @click="generativerule"
                    >生成规则</el-button
                  >
                  <span class="txt"
                    >点击按钮自动生成规则，也可以自己编辑信息</span
                  >
                </div>
              </div>
            </el-form-item>
            <orderShopInfo v-model="customerPaperwork"/>
            <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          </el-form>
        </main>

        <!-- 添加优惠券 -->
        <add-coupon
          :isShow="addCouponIsShow"
          @close="addCouponIsShow = false"
          @funcMes="addStatus"
        ></add-coupon>

        <!-- 自营=====添加优惠券 -->
        <self-support-addCoupon
          :isShow="selfSupportAddCouponIsShow"
          @close="selfSupportAddCouponIsShow = false"
          @funcMes="addStatusCoupon"
        ></self-support-addCoupon>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button class="returnBtn" @click="retrunMethod()"
        >返回上一页</el-button
      >
      <el-button
        class="returnBtn createBtn"
        @click="saveDraft"
        v-if="hasDraftBtn"
        >存为草稿</el-button
      >
      <el-button class="keepBtn" @click="setActivity" v-preventReClick>
        保存并完成设置
      </el-button>
    </div>
    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form
        style="margin: 20px 0"
        :inputData="commodityList"
        @toParentVal="searchContent"
        :immediately="true"
      ></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img
              :src="scope.row.logo"
              class="avar"
              alt="商品图片"
              style="height: 60px; width: 60px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="chooseShop(scope.row)"
              v-loading="sureLoading"
              style="width: 50px"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalList"
      ></el-pagination>
    </el-dialog>
    <!-- 选择优惠券 -->
    <selectPrize v-model="dialogPrize" @closePrize="closePrize" @close="dialogPrize = false"></selectPrize>
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="itemListForFilter"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="isEdit"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :isShowFirst="true"
      :isShowJingdou="false"
      :isShowShopPoints="false"
      :isShowEK="false"
      :isShowIQY="false"
      :isShowPLUS="false"
      :isShowHongBao="false"
      :isShowGiftCard="false"
      :isShowDirectlyFill="false"
      defaultSelect="third"
      @choose-shop="getTheData"

    >
    </selectProduct>
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import addCoupon from "./add_coupon";
import selfSupportAddCoupon from "./selfSupport_add_coupon"; //自营
import inputForm from "../../components/inputForm";
import {
  querydetail,
  closeSellerCouponWrite,
} from "@/api/integralCenter/couponWriteController.js";
import QRCode from "qrcodejs2";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/analysis/ware-controller.js";
import {
  setActivityList,
  uploadpic,
  setActivityVenderType,
  inquireActivity,
  changeActivity,
  updateActivity
} from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { mapState } from "vuex";
import { checkProduct } from "@/api/integralCenter/prizeCenter.js";
import information from '@/views/integralCenter/components/information.vue';
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import selectProduct from "./select_product.vue";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 10,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    addCoupon,
    inputForm,
    selfSupportAddCoupon,
    selectPrize,
    information,
    selectGoodsMonitor,
    selectProduct
  },
  computed: {
    ...mapState(["venderType"]),
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.singleCopy;
    },
     isEdit() {
      return this.activityData.isEdit
    },
    isDisabled() {
      return this.activityData && this.activityData.status == 2
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      }
    },
    venderType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.ruleDTO.orderPaymentType = 1;
        }
      },
      immediate: true,
    }
  },
  data() {
    return {
      itemArr: [],
      prizeList: [],
      JingdouCount: {
        prizeCount: 0,
      },
      echoDate: {},
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      itemListForFilter: [],
      selectGoodsState: false,
      ruleDTO: {
        condFollow: 0,
        activityTargetType: '2', // 固定值
        allowLevel: "-1",
        plusObject: 0,
        crowdIds: "",
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        orderCompleteLimitCount: "",
        orderCompleteMaxCount: "",
        orderCompleteLimitPayment: "",
        orderCompleteMaxPayment: "",
        lastOrderCompleteTimeType: 0,
        lastOrderCompleteStartDay: "",
        lastOrderCompleteEndDay: "",
        lastOrderCompleteStartTime: "",
        lastOrderCompleteEndTime: "",
        isCheckOpenCardTime: "",
        openCardStartTime: "",
        openCardEndTime: "",
        // 下单条件 start
        exchangeConditions: 0, // 参与条件，0满足参与身份即可参与 1先下单后兑换
        orderStartTime: "", // 下单时间范围起始
        orderEndTime: "", // 下单时间范围结束
        orderPaymentType: 0, // 金额统计类型，0实付金额 1订单金额
        filterType: 0, // 商品要求，0全部商品 1指定商品 2排除商品
        skuIdList: [], // skuId集合
        filterSkuType: 0, // 指定商品规则 0/null:只要订单包含指定商品就整单计算 1:仅统计订单内指定商品的金额和件数
        itemLimitCount: "", // 商品件数及以上
        orderPaymentLimit: "", // 订单金额及以上
        orderType: 0, // 订单状态， 0已付款 1完成
        orderCountType: 0, // 订单门槛统计方式 0 单笔满 1累计满
        goShopSetting: 0, // 跳转设置 0不跳转 1跳转店铺y
        goShopAppId: "", // 跳转店铺id
        goShopUrl: "", // 跳转店铺url
        // 下单条件 end
      },
      customerPaperwork: {},
      sureLoading: false,
      isKeyActivity: 0,
      placementPosition: [],
      localStep: this.stepNum,
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      fileList: [],
      memberLevelPointsDTOList: [],
      butActive: 1,
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      // 表单值
      form: {
        logo: "",
        activityName: "",
        ruleDescription: "",
        price: null,
        exchangeTimes: null,
        quantityTotal: null,
        startTime: null,
        endTime: null,
        memberLevelPoints: "",
        couponRedemptionType: "",
      },
      level: [],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        { value: "非会员", label: 0, point: "", levelName: "非会员" },
        { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        quantityTotal: {
          required: true,
          message: "请输入总份数",
          trigger: "blur",
        },
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft: false,
      dialogPrize: false,
    };
  },
  mounted() {
    console.log("this.venderType", this.venderType);
    this.getLevel();
    this.init();
    if (!this.valueRow) {
      this.form.startTime = this.$getDate(30)[0];
      this.form.endTime = this.$getDate(30)[1];
      this.activityTimeChange();
    }
  },
  methods: {
    getTheData(data, prizeType) {
      let obj = {
        giftType: "",
        price: "",
        logo: "",
        assetsId: "",
        prizeType: 3,
        title: "",
        skuId: "",
        singleAmount: 1,
        isGoodManage: 0,
        budgetRemain: "",
      }
      if (data.giftType) {
        obj.giftType = Number(data.giftType);
      }
      obj.price = Number(data.discount);

      obj.assetsId = Number(data.couponId || data.skuId);
      obj.logo = data.logo;
      obj.prizeType = prizeType;
      obj.title = data.name;

      if (data.singleAmount) {
        obj.singleAmount = data.singleAmount;
      }
      if (prizeType == 3) {
        obj.skuId = data.skuId;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          obj.skuId = data.skuId;
          delete obj.isGoodManage
        } else {
          obj.isGoodManage = data.isGoodManage;
          obj.budgetRemain = data.budgetRemain;
        }
      }
      this.prizeList = [obj]
      this.form.activityName = obj.title.substring(0, 15);
      this.form.price = obj.price;
      this.form.prizeType = obj.prizeType;
      if(!this.form.isGoodManage) {
        this.form.wareId = data.categoryId;
      }
      this.form.logo = obj.logo;
      this.form.singleAmount = obj.singleAmount;
      this.form.assetsId = obj.assetsId;
      this.form.isGoodManage = obj.isGoodManage;
      this.form.budgetRemain = obj.budgetRemain;
    },
    openPrize() {
      this.itemArr = this.prizeList;
      if(this.prizeList.length) {
        this.JingdouCount.prizeCount = 0;
        this.echoDate = this.prizeList[0];
      }
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
      }
      this.selectGoodsState = false;
    },
    // 奖品确定
    closePrize(val, params) {
      console.log(params);
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        this.butActive = 2;
        this.couponTxt = params;
        this.couponTxt.beginTime = params.takeBeginTime;
        this.couponTxt.endTime = params.takeEndTime;
        if (this.venderType) {
          this.form.quantityTotal = params.num;
        } else {
          this.couponId = Number(params.couponId);
        }
      }
      this.dialogPrize = false;
    },
    updata() {
      this.$forceUpdate();
    },
    init() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          imageName: "",
          templateUrl: "",
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      if (
        this.tabActive == 10 ||
        (this.activityData && this.activityData.id == 10)
      ) {
        this.giftList[0].templateUrl =
          "https://jdminiapp.yucrm.cn/html/images/Preview/yhq.png";
        this.giftList[0].imageName = "积分优惠券";
      } else {
        this.giftList[0].templateUrl =
          "https://jdminiapp.yucrm.cn/html/images/Preview/sw.png";
        this.giftList[0].imageName = "创建积分兑换实物";
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    // 复制回显
    getDetail() {
      inquireActivity(this.valueRow.id).then((res) => {
        if(res.data.ruleDTO) {
          this.ruleDTO = res.data.ruleDTO;
        }
        if(res.data.ruleDTO.exchangeConditions == null || res.data.ruleDTO.exchangeConditions == undefined) {
          res.data.ruleDTO.exchangeConditions = 0;
          res.data.ruleDTO.orderStartTime = "";
          res.data.ruleDTO.orderEndTime = "";
          res.data.ruleDTO.orderPaymentType = 0;
          res.data.ruleDTO.filterType = 0;
          res.data.ruleDTO.skuIdList = [];
          res.data.ruleDTO.filterSkuType = 0;
          res.data.ruleDTO.itemLimitCount = "";
          res.data.ruleDTO.orderPaymentLimit = ""; 
          res.data.ruleDTO.orderType = 0;
          res.data.ruleDTO.orderCountType = 0;
        } else if (res.data.ruleDTO.exchangeConditions == 1 && res.data.ruleDTO.skuIdList && res.data.ruleDTO.skuIdList.length) {
          getTaobaoItemListSku({
            current: 1,
            size: res.data.ruleDTO.skuIdList.length,
            skuIdStr: res.data.ruleDTO.skuIdList.join(','),
          }).then(res2 => {
            this.itemListForFilter = res2.data.records;
          })
        }
        this.ruleDTO.goShopSetting = res.data.ruleDTO && res.data.ruleDTO.goShopSetting || 0;
        if(this.venderType) {
          this.ruleDTO.orderPaymentType = 1;
        }
        this.form = res.data;
        this.prizeList = [{
          title: res.data.activityName,
          price: res.data.price,
          prizeType: res.data.prizeType,
          wareId: res.data.wareId,
          categoryId: res.data.wareId,
          assetsId: res.data.assetsId,
          isGoodManage: res.data.isGoodManage ? res.data.isGoodManage : 0,
          budgetRemain: res.data.budgetRemain,
          logo: res.data.logo,
          giftType: res.data.giftType || "1",
          prizeType: 3,
        }]
        this.form.exchangeTimes =
          this.form.exchangeTimes == -1 ? null : res.data.exchangeTimes;
        this.form.startTime = res.data.startTime ? res.data.startTime : null;
        this.form.endTime = res.data.endTime ? res.data.endTime : null;
        // 是否重点活动回显
        this.isKeyActivity = res.data.isKeyActivity || 0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];
        this.activityTimeChange();
        // 店铺名称类型回显
        this.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : {};
        // 会员回显
        if (!this.activityData.isCopy) {
          const checkedLevel = res.data.memberLevelPointsDTOList
            .filter((item) => item.allow)
            .map((item) => item.level);
          let allLevel = true;
          let isAll = true;
          this.memberLevelList.forEach((list) => {
            if (!checkedLevel.includes(list.value)) {
              allLevel = false;
            }
          });
          res.data.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow) {
              if (item.point != res.data.memberLevelPointsDTOList[0].point) {
                isAll = false;
              }
            }
          });
          // 全部会员
          if (allLevel) {
            this.memberLe = true;
            this.level = this.memberLevelList.map((item) => item.value);
          } else {
            this.memberLe = false;
            this.level = checkedLevel;
          }
          // 统一设置
          if (isAll) {
            this.isLevelSet = false;
            this.form.memberLevelPoints =
              res.data.memberLevelPointsDTOList[0].point;
          } else {
            this.isLevelSet = true;
            this.memberLevelList.forEach((item) => {
              res.data.memberLevelPointsDTOList.forEach((list) => {
                if (item.value == list.level && list.allow) {
                  item.point = list.point;
                }
              });
            });
          }
        }
        // singleCopy为true时，不回显，此处有多个判断是否为复制活动，难以判断
        if (
          this.tabActive == 10 &&
          res.data.couponId &&
          !this.activityData.singleCopy
        ) {
          querydetail(Number(res.data.couponId)).then((res) => {
            this.butActive = 2;
            this.couponTxt = res.data;
            let sum1 = res.data.beginTime.split(" ");
            let sum2 = res.data.endTime.split(" ");
            this.couponTxt.beginTime = sum1[0];
            this.couponTxt.endTime = sum2[0];
            this.couponId = res.data.couponId;
          });
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
    },
    onShowAddCoupon() {
      this.dialogPrize = true;
      // if (this.venderType == true) {
      //   this.selfSupportAddCouponIsShow = true;
      // } else {
      //   this.addCouponIsShow = true;
      // }
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = {
            value: item.customerLevel,
            label: item.customerLevelName,
            point: "",
          };
          return obj;
        });
        // 默认全部选中
        this.level = res.data.map((item) => item.customerLevel);
        // 复制、草稿编辑
        if (this.valueRow && this.valueRow.id) {
          this.isCopy = this.activityData.isCopy;
          this.getDetail();
        }
      });
    },
    //输入框限制负数
    checkputn0(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
      return e.target.value;
    },
    //输入框限制负数
    checkputn1(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //返回
    retrunMethod() {
      if (this.isCopy && this.localStep != 0) return (this.localStep = 0);
      this.form.activityName = "";
      this.form.logo = "";
      this.form.activityName = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      this.form.startTime = "";
      this.form.endTime = "";
      this.level = [0, 1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      if (this.localStep == 0) this.$emit("return");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if (!this.form.endTime || !this.form.startTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.pointUserInfo.expiredIn
      ).valueOf();
      let hdInvalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.form.endTime = null;
        return;
      }
      if (end > hdInvalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (start < nowTime) {
        // this.$message.warning("开始时间不能小于当前时间");
        // this.form.startTime = null;
        // return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.form.endTime).getTime() -
          new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 隐藏添加优惠券组件
    addCouponChange() {
      this.addCouponIsShow = false;
      // console.log(111);
    },
    //取消优惠券
    createActivity() {
      if (this.venderType) {
        this.butActive = 1;
        this.onShowAddCoupon()
      } else {
        let couponId = this.couponId;
        closeSellerCouponWrite(couponId)
          .then((res) => {
            if (res && res.code == 1) {
              this.butActive = 1;
              this.onShowAddCoupon()
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map((item) => item.value);
      } else {
        this.level = [];
      }
    },

    checkTheChange(val) {
      if (val.length == 6) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    //获取优惠券信息
    addStatus(val) {
      console.log(val, "11223");

      this.butActive = 2;
      this.couponId = Number(val);
      querydetail(this.couponId)
        .then((res) => {
          this.couponTxt = res.data;
          let sum1 = res.data.beginTime.split(" ");
          let sum2 = res.data.endTime.split(" ");
          this.couponTxt.beginTime = sum1[0];
          this.couponTxt.endTime = sum2[0];
          // console.log(res);
        })
        .catch((res) => {});
    },

    //自营店铺获取优惠券信息
    addStatusCoupon(data) {
      console.log("data", data);
      this.butActive = 2;
      this.couponTxt = data;
      this.form.quantityTotal = data.num;
      this.couponTxt.startTime = data.startTime;
      this.couponTxt.endTime = data.endTime;
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getShopList();
      this.getSeller();
    },
    //获取店铺商品
    getShopList() {
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalList = res.data.total ? Number(res.data.total) : 0;
      });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择
    chooseShop(val) {
      console.log(val);
      const skuIds = [val.skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              this.form.activityName = val.skuName.substr(0, 15);
              this.form.price = val.jdPrice;
              this.form.wareId = val.categoryId;
              this.form.logo = val.logo;
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // this.form.activityName = val.skuName.substr(0, 15);
      // this.form.price = val.jdPrice;
      // this.form.wareId = val.categoryId;
      // this.form.logo = val.logo;
      // this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 1.5;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 生成规则
    generativerule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.form.activityName.length > 0) {
        text1 = "礼品名称：" + this.form.activityName;
      }
      if (this.form.price) {
        text2 = "礼品价值" + this.form.price + "元";
      }
      if (this.form.exchangeTimes) {
        text3 = "每人限兑次数：" + this.form.exchangeTimes + "次";
      } else {
        text3 = "每人限兑次数：不限次数";
      }
      if (this.form.quantityTotal) {
        text4 = "总份数：" + this.form.quantityTotal;
      }
      if (this.form.startTime && this.form.endTime) {
        text5 = "上下架时间：" + this.form.startTime + "至" + this.form.endTime;
      }
      if (this.level && this.level.length) {
        let levelText = [];
        this.memberLevelList.forEach((item) => {
          if (
            this.level.includes(item.value) &&
            ((!this.isLevelSet && this.form.memberLevelPoints) || item.point)
          ) {
            const obj =
              item.label +
              ":" +
              (this.isLevelSet ? item.point : this.form.memberLevelPoints) +
              "积分";
            levelText.push(obj);
          }
        });
        text6 = "兑换所需等级及积分:" + levelText.splice(",");
      }
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      this.form.ruleDescription = newText;
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      }
    },
    //创建礼品兑换活动
    async setActivity() {
      console.log(this.level);
      if (!this.isDraft) {
        //活动创建限制
        if (!this.form.activityName) {
          this.$message.warning("请输入礼品名称");
          return;
        }
        await this.$refs.information.verify();
        if (this.butActive == 1 && this.tabActive == 10) {
          this.$message.warning("请添加优惠券");
          return;
        }
        // if (!this.form.price && this.tabActive == 9) {
        //   this.$message.warning("请输入礼品价值");
        //   return;
        // }
        if (!this.form.logo && this.tabActive == 9) {
          this.$message.warning("请添加礼品图片");
          return;
        }
        if (this.ruleDTO.exchangeConditions == 1 && this.tabActive == 9) {
          if(!this.ruleDTO.orderEndTime || !this.ruleDTO.orderEndTime){
            this.$message.warning("请选择下单时间");
            return;
          };
          if(new Date(this.ruleDTO.orderEndTime).getTime() > new Date(this.ruleDTO.endTime).getTime()){
            this.$message.warning("下单结束时间不能大于活动结束时间");
            return;
          };
          if(this.ruleDTO.filterType != 0 && !this.itemListForFilter.length){
            this.$message.warning("请选择指定/排除商品");
            return;
          };
          if(!this.ruleDTO.orderPaymentLimit){
            this.$message.warning("请输入订单金额限制");
            return;
          }
          if(this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId){
            this.$message.warning("请输入小程序appId");
            return;
          }
          if(this.ruleDTO.goShopSetting == 2 && !this.ruleDTO.goShopUrl){
            this.$message.warning("请输入跳转链接");
            return;
          }
        }
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.warning("请输入上下架时间");
          return;
        }
        let nowTime = new Date().getTime();
        let start = new Date(this.form.startTime).valueOf();
        let end = new Date(this.form.endTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (end < start) {
          this.$message.warning("结束时间不能小于开始时间");
          return;
        }
        if (this.level.length == 0) {
          this.$message.warning("请输入兑换所需等级");
          return;
        }
        if (!this.form.quantityTotal && this.tabActive == 9) {
          this.$message.warning("请输入总份数!");
          return;
        }
        // 兑换所需积分校验
        if (this.isLevelSet) {
          let flag = false;
          this.memberLevelList.forEach((list) => {
            if (!list.point) {
              flag = true;
            }
          });
          if (flag) return this.$message.warning("请输入兑换所需积分");
        } else {
          if (!this.form.memberLevelPoints) {
            this.$message.warning("请输入兑换所需积分");
            return;
          }
        }
        if (!this.form.ruleDescription) {
          this.$message.warning("请输入规则说明");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      let obj = {
        activityName: "",
        activityType: 9,
        couponId: 0,
        endTime: "",
        exchangeTimes: -1,
        giftType: 0,
        logo: "",
        memberLevelPointsDTOList: [],
        price: 0,
        quantityTotal: 0,
        ruleDescription: "",
        startTime: "",
        title: "",
        wareId: 0,
      };
      obj = this.form;
      obj.ruleDTO = this.ruleDTO;
      if(obj.ruleDTO.filterType != 0) {
        obj.ruleDTO.skuIdList = this.itemListForFilter.map(v => v.skuId);
      }
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(',');
      // 处理兑换所需积分
      obj.memberLevelPointsDTOList = this.memberLevelList.map((item) => {
        const checked = this.level.includes(item.value);
        return {
          allow: checked,
          level: item.value,
          levelName: item.label,
          point: checked
            ? this.isLevelSet
              ? item.point
              : this.form.memberLevelPoints
            : 0,
        };
      });
      if (this.couponTxt.discount != null) {
        obj.price = Number(this.couponTxt.discount);
      } else {
        obj.price = this.form.price;
        obj.title = this.form.activityName;
        obj.wareId = this.form.wareId;
        if (this.form.wareId != null) {
          obj.giftType = 1;
        } else {
          obj.giftType = 2;
        }
      }
      obj.activityName = this.form.activityName;
      obj.activityType = this.tabActive;
      obj.couponId = this.couponId;
      // 店铺名称类型
      obj.customerPaperwork = JSON.stringify(this.customerPaperwork);
      if (this.form.exchangeTimes!=null) {
        obj.exchangeTimes = Number(this.form.exchangeTimes)==0?'':Number(this.form.exchangeTimes);
      }
      if (this.form.quantityTotal) {
        obj.quantityTotal = Number(this.form.quantityTotal);
      }
      // 草稿箱
      if (this.isDraft) {
        obj.status = 5;
        if (!obj.couponId) {
          obj.couponId = null;
        }
      }else {
         // 保存正式活动不需要status
         if (obj.status) {
           delete obj.status;
        }
       }
      // 草稿箱编辑-添加活动id
      if (this.isDraftEdit) {
        obj.id = this.valueRow.id;
      }
      if (this.activityData && this.activityData.singleCopy) {
        delete obj.id;
        delete obj.status;
      }
      // form.quantityTotal
      console.log(obj, "aaaa");
      // return;
      if(this.isEdit) {
        obj.id = this.valueRow.id
        let editAip = changeActivity;
        if(this.activityData && this.activityData.status == 2) {
          editAip = updateActivity;
        }
        editAip(obj)
        .then((res) => {
          if (res && res.id || res.code == 1) {
            this.$router.push({
              name: "throw",
              query: {
                id: res.id || this.valueRow.id,
                activityType: res.activityType || this.activityData.activityType,
              },
            });
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.message||"修改失败");
          }
        })
        .catch((res) => {});
        return
      }

      if (this.venderType) {
        // debugger
        obj.safeCoupon = this.couponTxt;
        // obj.quantityTotal = obj.safeCoupon.issuedQuantity;
        obj.takeRule = obj.safeCoupon.limitRule;
        obj.quantityTotal = Number(this.form.quantityTotal);
        // obj.safeCoupon.startTime = "2022-01-25"
        // obj.safeCoupon.takeBeginTime = "2022-01-26"
        // obj.safeCoupon.endTime = "2022-02-25"
        // obj.safeCoupon.takeEndTime = "2022-02-24"

        setActivityVenderType(obj).then((res) => {
          if (res && res.code == 1) {
            if (this.isDraft) {
              this.$emit("return", true);
            } else {
              this.memberLevelPointsDTOList = [];
              this.$message.success(res.message);
              // let routeUrl = this.$router.resolve({
              //   path: "/integralCenter/integralMall",
              //   query: { tabAct: 3 },
              // });
              // window.open(routeUrl.href, "_self");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        setActivityList(obj)
          .then((res) => {
            if (res && res.code == 1) {
              if (this.isDraft) {
                this.$emit("return", true);
              } else {
                this.memberLevelPointsDTOList = [];
                this.$message.success(res.message);
                // let routeUrl = this.$router.resolve({
                //   path: "/integralCenter/integralMall",
                //   query: { tabAct: 3 },
                // });
                // window.open(routeUrl.href, "_self");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.level-wrap {
  display: flex;
  /deep/.el-checkbox-group {
    margin-right: 16px;
  }
}
.firststep {
  min-height: 820px;
  box-sizing: border-box;
  padding: 0px 35px 25px;
}
.create_coupons {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // min-height: 880px;
  margin: -24px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 0px 0 0 24px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #7b61ff;
      color: #7b61ff;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 200px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        // margin-left: 20px;
        border: 1px solid #7b61ff;
        color: #7b61ff;

        background: rgba(123, 97, 255, 0.1);
        font-size: 13px;
        &:hover {
          background-color: #7b61ff;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #7f85e9;
      background: rgba(127, 133, 233, 0.1);
      color: #7f85e9;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    line-height: 32px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
</style>
